export const KUDOS_SUPPORT_EMAIL = 'support@kudos.com'
